import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../Assets/images/logo.png";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [mGalleryOpen, setMGalleryOpen] = useState(false);
  const [mDeshOpen, setMDeshOpen] = useState(false);

  const statesList = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
    'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
  ];

  const galleryRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (galleryRef.current && !galleryRef.current.contains(e.target)) {
        setGalleryOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const navBase = "transition-colors duration-200";
  const navHover = "hover:text-red-600";
  const navActive = "text-red-600 font-semibold";

  return (
    <>
      {/* <header className="fixed top-0 left-0 w-full z-50 bg-[#0B2A4A]"> */}

      <header className="fixed top-[40px] left-0 w-full z-50 bg-[#0B2A4A]">

        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button onClick={() => setMobileMenuOpen(true)}>
              <i className="fa-solid fa-bars text-3xl text-white"></i>
            </button>

            {/* <div className="relative hidden md:flex items-center">
              <i className="fas fa-search absolute left-3 text-gray-500 text-sm"></i>
              <input
                type="text"
                placeholder="Search..."
                className="w-64 pl-9 pr-4 py-2 bg-gray-100 rounded-md text-sm focus:outline-none"
              />
            </div> */}
          </div>

          <div className="flex items-center gap-3">
            <Link to="/">
              <img
                src={logo}
                alt="logo"
                className="w-12 h-12 md:w-20 md:h-20 object-contain"
              />
            </Link>
            <div className="hidden md:block text-white font-semibold text-lg">
              Bundeli Chugli & Hindi Chugli
            </div>
          </div>

          <Link
            to="/contact"
            className="flex items-center justify-center gap-2
              bg-red-600 text-white h-10 w-10 sm:w-auto
              px-0 sm:px-4 rounded-full sm:rounded-md
              border border-red-600 text-sm font-medium
              hover:bg-white hover:text-red-600 transition"
          >
            <i className="fa-regular fa-user text-sm"></i>
            <div className="hidden sm:inline">Contact Now</div>
          </Link>
        </div>

        {/* DESKTOP NAV */}
        <nav className="max-lg:hidden bg-white border-t">
          <ul className="max-w-7xl mx-auto px-4 flex justify-center gap-10 py-3 text-black">

            <li>
              <NavLink to="/" end className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                होम
              </NavLink>
            </li>

            <li className="relative group">
              <NavLink to="/category/desh" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover} flex items-center gap-1`
              }>
                देश <i className="fa-solid fa-chevron-down text-xs"></i>
              </NavLink>
              
              {/* Dropdown for States */}
              <div className="absolute left-0 top-full pt-2 hidden group-hover:block z-50">
                <div className="bg-white border rounded-md shadow-lg p-3 w-[600px] grid grid-cols-3 gap-2 max-h-[400px] overflow-y-auto">
                  {statesList.map(state => (
                    <Link key={state} to={`/category/desh?state=${encodeURIComponent(state)}`} className={`block px-2 py-1 text-sm ${navBase} ${navHover}`}>
                      {state}
                    </Link>
                  ))}
                </div>
              </div>
            </li>

            <li>
              <NavLink to="/category/videsh" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                विदेश
              </NavLink>
            </li>

            <li>
              <NavLink to="/category/politics" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                राजनीति
              </NavLink>
            </li>

            <li>
              <NavLink to="/category/cinema" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                सिनेमा
              </NavLink>
            </li>

            <li>
              <NavLink to="/category/sports" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                खेल
              </NavLink>
            </li>

            <li>
              <NavLink to="/category/health" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                स्वास्थ्य
              </NavLink>
            </li>

            <li>
              <NavLink to="/category/dharm" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                धर्म
              </NavLink>
            </li>

            <li>
              <NavLink to="/category/science-technology" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                विज्ञान और प्रौद्योगिकी
              </NavLink>
            </li>
             <li>
              <NavLink to="/category/general" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                सामान्य
              </NavLink>
            </li>

            {/* Gallery */}
            <li ref={galleryRef} className="relative">
              <button
                onClick={() => setGalleryOpen(!galleryOpen)}
                className={`${navBase} ${navHover} flex items-center gap-1`}
              >
                Gallery <i className="fa-solid fa-chevron-down text-xs"></i>
              </button>

              {galleryOpen && (
                <ul className="absolute left-0 top-full mt-2 bg-white border rounded-md min-w-[200px] shadow z-50">
                  {[
                    ["Photo Gallery", "/gallery/photos"],
                    ["Video Gallery", "/gallery/videos"],
                  ].map(([label, link]) => (
                    <li key={link}>
                      <Link to={link} className={`block px-4 py-2 ${navBase} ${navHover}`}>
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            <li>
              <NavLink to="/about" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                हमारे बारे में
              </NavLink>
            </li>

            <li>
              <NavLink to="/contact" className={({ isActive }) =>
                `${navBase} ${isActive ? navActive : navHover}`
              }>
                संपर्क
              </NavLink>
            </li>

          </ul>
        </nav>
      </header>

      {/* MOBILE MENU */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 z-[999] bg-black/60"
          onClick={() => setMobileMenuOpen(false)}
        >
          <div
            className="bg-white w-[85%] max-w-sm h-full p-5 overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between mb-6">
              <img src={logo} alt="logo" className="w-14" />
              <button onClick={() => setMobileMenuOpen(false)}>
                <i className="fa-solid fa-xmark text-2xl"></i>
              </button>
            </div>

            <ul className="space-y-4 font-medium text-black">
              {[
                ["/", "होम"],
                ["/category/videsh", "विदेश"],
                ["/category/politics", "राजनीति"],
                ["/category/cinema", "सिनेमा"],
                ["/category/sports", "खेल"],
                ["/category/health", "स्वास्थ्य"],
                ["/category/dharm", "धर्म"],
                ["/category/science-technology", "विज्ञान और प्रौद्योगिकी"],
                ["/category/general", "सामान्य"],
              ].map(([link, label]) => (
                <li key={link}>
                  <Link to={link} onClick={() => setMobileMenuOpen(false)} className={navHover}>
                    {label}
                  </Link>
                </li>
              ))}

              <li>
                <div className="flex justify-between items-center w-full">
                  <Link to="/category/desh" onClick={() => setMobileMenuOpen(false)} className={`${navHover} flex-1`}>
                    देश
                  </Link>
                  <button onClick={() => setMDeshOpen(!mDeshOpen)} className="p-2">
                    <i className="fa-solid fa-chevron-down"></i>
                  </button>
                </div>
                {mDeshOpen && (
                  <ul className="pl-4 pt-2 space-y-2 text-sm max-h-[250px] overflow-y-auto bg-gray-50 rounded p-2">
                    {statesList.map((state) => (
                      <li key={state}>
                        <Link to={`/category/desh?state=${encodeURIComponent(state)}`} onClick={() => setMobileMenuOpen(false)}>
                          {state}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>

              <li>
                <button
                  onClick={() => setMGalleryOpen(!mGalleryOpen)}
                  className={`${navBase} ${navHover} flex justify-between w-full`}
                >
                  Gallery <i className="fa-solid fa-chevron-down"></i>
                </button>

                {mGalleryOpen && (
                  <ul className="pl-4 pt-2 space-y-2 text-sm">
                    <li><Link to="/gallery/photos" onClick={() => setMobileMenuOpen(false)}>Photo Gallery</Link></li>
                    <li><Link to="/gallery/videos" onClick={() => setMobileMenuOpen(false)}>Video Gallery</Link></li>
                  </ul>
                )}
              </li>

              <li><Link to="/about" onClick={() => setMobileMenuOpen(false)}>हमारे बारे में</Link></li>
              <li><Link to="/contact" onClick={() => setMobileMenuOpen(false)}>संपर्क</Link></li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
